import { render, staticRenderFns } from "./PrintConfiguration.vue?vue&type=template&id=ca6e4b18&"
import script from "./PrintConfiguration.vue?vue&type=script&lang=js&"
export * from "./PrintConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports